import React from 'react'
import PropTypes from 'prop-types'
import { CancelButton, GridContainer, GridItem } from './QuoteBidSeller.styles'

/**
 * Button cancel component.
 */
const CancelBid = props => {
  const { id, onCancelBidShowDialog } = props
  const handleCancelBidShowDialog = () => onCancelBidShowDialog(id)

  return (
    <GridContainer justifyContent="flex-end">
      <GridItem xs={12}>
        <CancelButton onClick={handleCancelBidShowDialog}>Anular cotización</CancelButton>
      </GridItem>
    </GridContainer>
  )
}

CancelBid.propTypes = {
  id: PropTypes.number.isRequired,
  onCancelBidShowDialog: PropTypes.func.isRequired
}

export default CancelBid
